import React, { Component } from 'react';
import { withRouter } from '../../withRouter';
import { Spinner, } from 'react-bootstrap';
import { connect, } from 'react-redux';

import styles from 'components/Roku/QRLogin/QRLogin.module.scss';
import QRCode from 'qrcode.react';
import { requestQRSession, getQRSession } from 'actions/auth';
import DotLoader from 'components/Utlility/DotLoader';
import { getBaseUrl } from 'helpers/url';

class QRLogin extends Component {

    constructor(props) {
        super(props);

        this.pollQRSessionInterval = null;

        this.state = {
            sessionID: null,
            expires: null,
            expired: false,
            pollCount: 0,
        };
    }

    componentWillMount() {
        this.generateQRSession();
    }

    componentWillUnmount() {
        clearInterval(this.pollQRSessionInterval);
    }

    generateQRSession = () => {
        clearInterval(this.pollQRSessionInterval);
        if (this.props.auth.isLoggedIn) return;
        this.setState({ sessionID: null, expired: false })
        const oldSessionData = JSON.parse(localStorage.getItem("QRSessionData"));
        this.tryRequestQRSession(oldSessionData);
    }

    tryRequestQRSession = (oldSessionData, retryCount = 10) => {
        console.log("Requesting QR Login Session, retry count: ", retryCount);
        this.props.requestQRSession(oldSessionData?.sessionID, this.props.TTL ?? 180)
            .then((res) => {
                if (res.status === "Error") throw res.message;
                console.log(res);
                this.updateExpiresIn(new Date(res.expires));
                this.setState({ sessionID: res.sessionID, expired: false });
                this.pollQRSessionInterval = setInterval(this.pollForQRAuth, 1000);
            }).catch(async (err) => {
                console.log("rejected", err);
                this.setState({ errorMessage: err });
                if (retryCount > 0) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    this.tryRequestQRSession(oldSessionData, retryCount - 1);
                }
                else {
                    this.setState({ expired: true });
                    this.updateExpiresIn(new Date());
                }
            });
    }

    pollForQRAuth = () => {
        this.setState({ pollCount: this.state.pollCount + 1 });
        this.updateExpiresIn(this.state.expires);
        if (this.state.pollCount % 4 !== 0) return; // Poll every 4 seconds

        this.props.getQRSession(this.state.sessionID)
            .then((res) => {
                console.log("poll " + res.expires)
                this.updateExpiresIn(new Date(res.expires + 'Z'));
                if (res.user) {
                    clearInterval(this.pollQRSessionInterval);
                    console.log("Session Authorized", res.user.token);
                    this.props.onLogin(this.state.sessionID);
                } else if (res.error) {
                    this.handlePollError(res.error);
                }
            })
            .catch((err) => {
                this.handlePollError(err);
            });
    }

    handlePollError = (err) => {
        clearInterval(this.pollQRSessionInterval);
        console.log("Session Expired", err);
        localStorage.removeItem("QRSessionData");
        this.setState({ sessionID: null, errorMessage: "Your session has expired please restart the app.", expired: true });
        this.updateExpiresIn(new Date());
    }

    updateExpiresIn = (expires) => {
        const now = new Date();
        const timeLeft = new Date(expires - now);
        if (timeLeft.getTime() <= 0) {
            this.setState({ expired: true, sessionID: null });
            clearInterval(this.pollQRSessionInterval);
        } else {
            this.setState({ expires, sessionExpiresIn: timeLeft });
        }
    }

    getExpiresInString = () => {
        if (!this.state.sessionExpiresIn) return "-";
        var minuets = this.state.sessionExpiresIn.getMinutes();
        var seconds = this.state.sessionExpiresIn.getSeconds();
        minuets = isNaN(minuets) ? 0 : minuets;
        seconds = isNaN(seconds) ? 0 : seconds;
        if (minuets <= 0 && seconds <= 0) return "Expired";
        return `${minuets}m ${seconds}s`;
    }

    render() {
        const baseUrl = getBaseUrl();
        const url = `${baseUrl}/login?QRSessionID=${this.state.sessionID}&loginAppType=${this.props.appType}`;

        return (
            <React.Fragment>
                <div className={styles.QRContainer}>
                    {
                        this.state.sessionID ?
                            <QRCode
                                size={256}
                                style={{ width: "min(20vw, 20vh)", height: "min(20vw, 20vh)" }}
                                bgColor="transparent"
                                fgColor={this.props.color ?? "white"}
                                className={styles.QR}
                                value={url}
                            />
                            :
                            <div style={{ margin: "auto", width: "min(20vw, 20vh)", height: "min(20vw, 20vh)" }} >
                                <div className={styles.center} >
                                    {this.state.expired ?
                                        this.props.expiredMessage
                                            ? <h4>{this.props.expiredMessage}</h4>
                                            : <button
                                                tabIndex={1}
                                                className={`${styles.button} ${styles.alternate}`}
                                                onClick={() => this.generateQRSession()}
                                            >
                                                Retry
                                            </button>
                                        :
                                        <DotLoader size="medium" variant="dark" />}
                                </div>
                            </div>
                    }
                    {
                        /*window.location.hostname === "localhost"*/ true ?
                            <a href={url}>
                                <h3 className={styles.scanMe} style={this.props.textStyle}>SCAN ME</h3>
                            </a> :
                            <h3 className={styles.scanMe} style={this.props.textStyle}>SCAN ME</h3>
                    }
                    <h4 className={styles.expires} style={this.props.textStyle}>
                        Expires In: {this.getExpiresInString()}
                    </h4>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        requestQRSession: (oldSessionID, ttl) => {
            return dispatch(requestQRSession(oldSessionID, ttl));
        },
        getQRSession: (QRSessionID) => {
            return dispatch(getQRSession(QRSessionID));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QRLogin));
